import { storeWrapper } from '../storeWrapper'
import { ospreyAPI } from '@repo/api/ospreyAPI'

const initialState = {
  isFetchingAddressSearch: false,
  isFetchingSingleAddress: false
}

export const useAddressesStore = storeWrapper('useAddressesStore', (set) => ({
  ...initialState,
  fetchAddresses: async (term) => {
    set({ isFetchingAddressSearch: true })

    const fetchedAddresses = await ospreyAPI({
      service: 'addresses',
      endpoint: 'Address/GetSuggestions',
      data: { term }
    })

    set({ isFetchingAddressSearch: false })

    return Promise.resolve(fetchedAddresses)
  },
  fetchSingleAddressById: async (id) => {
    set({ isFetchingSingleAddress: true })

    const singleAddress = await ospreyAPI({
      service: 'addresses',
      endpoint: 'Address/Get',
      data: { id }
    })

    set({ isFetchingSingleAddress: false })

    return Promise.resolve(singleAddress)
  },
  reset: () => set(initialState)
}))
